import { MilestonePathUi, MilestonePointUi } from "ui";
import { useQueueWorkflowStore } from "@elixir/stores";
import { WORKFLOW_VIEW_POPUP_STATE } from "@elixir/types";

const CreateViewSteps = () => {
  const createViewPopupState = useQueueWorkflowStore(
    (state) => state.createViewPopupState
  );
  const completePointStyle =
    "dr-text-darwin-touch-neutral-0 dr-bg-darwin-touch-primary-primary";
  const incompletePointStyle =
    "dr-text-darwin-touch-neutral-600 dr-bg-darwin-touch-neutral-0";
  const outerRingStyle = "dr-bg-darwin-touch-primary-bg-dark";
  const titleSelectStyle = "Caption1Bold";
  const titleUnselectStyle = "Caption1Medium";

  return (
    <div className="dr-flex dr-flex-row dr-space-x-8 dr-justify-center dr-px-16 dr-pt-16 dr-pb-8">
      <MilestonePointUi
        isCompleted={
          createViewPopupState === WORKFLOW_VIEW_POPUP_STATE.APPLY_FILTERS ||
          createViewPopupState === WORKFLOW_VIEW_POPUP_STATE.CONFIGURE_CARD ||
          createViewPopupState === WORKFLOW_VIEW_POPUP_STATE.CONFIRM_FILTERS
        }
        completePointStyle={completePointStyle}
        incompletePointStyle={
          createViewPopupState === WORKFLOW_VIEW_POPUP_STATE.VIEW_NAMING
            ? completePointStyle
            : incompletePointStyle
        }
        point="1"
        title="NAME YOUR VIEW"
        layoutDirection="column"
        titleStyle={
          createViewPopupState === WORKFLOW_VIEW_POPUP_STATE.VIEW_NAMING
            ? titleSelectStyle
            : titleUnselectStyle
        }
        outerRingStyle={outerRingStyle}
      />
      <div>
        <MilestonePathUi
          isCompleted={
            createViewPopupState === WORKFLOW_VIEW_POPUP_STATE.APPLY_FILTERS ||
            createViewPopupState === WORKFLOW_VIEW_POPUP_STATE.CONFIGURE_CARD ||
            createViewPopupState === WORKFLOW_VIEW_POPUP_STATE.CONFIRM_FILTERS
          }
          layoutAlignment="horizontal"
          completeStroke="#215FFF"
          inCompleteStroke="#D3DFFF"
        />
      </div>
      <MilestonePointUi
        isCompleted={
          createViewPopupState === WORKFLOW_VIEW_POPUP_STATE.CONFIGURE_CARD
        }
        point="2"
        title="SELECT FILTERS"
        layoutDirection="column"
        titleStyle={
          createViewPopupState === WORKFLOW_VIEW_POPUP_STATE.APPLY_FILTERS ||
          createViewPopupState === WORKFLOW_VIEW_POPUP_STATE.CONFIRM_FILTERS
            ? titleSelectStyle
            : titleUnselectStyle
        }
        outerRingStyle={outerRingStyle}
        completePointStyle={completePointStyle}
        incompletePointStyle={
          createViewPopupState === WORKFLOW_VIEW_POPUP_STATE.APPLY_FILTERS ||
          createViewPopupState === WORKFLOW_VIEW_POPUP_STATE.CONFIRM_FILTERS
            ? completePointStyle
            : incompletePointStyle
        }
      />
      {/* <div>
        <MilestonePathUi
          isCompleted={
            createViewPopupState === WORKFLOW_VIEW_POPUP_STATE.CONFIGURE_CARD
          }
          layoutAlignment="horizontal"
          completeStroke="#215FFF"
          inCompleteStroke="#D3DFFF"
        />
      </div>
      <MilestonePointUi
        point="3"
        title="CONFIGURE CARD"
        layoutDirection="column"
        titleStyle={
          createViewPopupState === WORKFLOW_VIEW_POPUP_STATE.CONFIGURE_CARD
            ? titleSelectStyle
            : titleUnselectStyle
        }
        outerRingStyle={outerRingStyle}
        completePointStyle={completePointStyle}
        incompletePointStyle={completePointStyle}
      /> */}
    </div>
  );
};

export default CreateViewSteps;
